import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import axios from 'axios';
import dayjs from 'dayjs';

const ArticleGraphWordCloudPinus = () => {
    const [selectedYear, setSelectedYear] = useState(2025);
    const [articleData, setArticleData] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState(null); // New state for storing the selected month
    const [selectedImagePath, setSelectedImagePath] = useState(null);
    const [chartOptions, setChartOptions] = useState({
        chart: {
            type: 'column'
        },
        title: {
            text: '기사발생 횟수'
        },
        xAxis: {
            categories: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월']
        },
        yAxis: {
            title: {
                text: '월별 기사 발생 수'
            }
        },
        plotOptions: {
            series: {
                cursor: 'pointer',
                point: {
                    events: {
                        click: function () {
                            setSelectedMonth(this.category); // Update to set selectedMonth on click
                            // console.log(this.category);
                        }
                    }
                }
            }
        },
        series: [{
            name: '기사 발생 수',
            data: []
        }]
    });

    const currentYear = new Date().getFullYear();
    const startYear = 1994;

    useEffect(() => {
        axios.get('https://disease.scnu.ac.kr/pinewilt/')
            .then(response => {
                setArticleData(response.data);
                setIsDataLoaded(true);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }, []);

    useEffect(() => {
        if (!isDataLoaded) return;

        const monthlyCounts = Array(12).fill(0);

        articleData.forEach(item => {
            const date = dayjs(item.date, 'YYYY-MM-DD');
            if (date.year() === selectedYear) {
                const month = date.month();
                monthlyCounts[month]++;
            }
        });

        setChartOptions(prevOptions => ({
            ...prevOptions,
            title: {
                text: `${selectedYear}년도 기사발생 횟수`
            },
            series: [{
                name: '기사 발생 수',
                data: monthlyCounts
            }]
        }));
    }, [articleData, selectedYear, isDataLoaded]);

    useEffect(() => {
        if (selectedMonth === null) return;

        const monthIndex = parseInt(selectedMonth.slice(0, -1));
        const imagePath = `./pinewilt_wordcloud/${selectedYear}_${monthIndex}.png`;
        setSelectedImagePath(imagePath);
        // console.log('Image path:', imagePath);
    }, [selectedMonth, selectedYear]); // Effect that runs when selectedMonth or selectedYear changes

    const handlePreviousYear = () => {
        setSelectedYear(prevYear => Math.max(prevYear - 1, startYear));
    };

    const handleNextYear = () => {
        setSelectedYear(prevYear => Math.min(prevYear + 1, currentYear - 1));
    };

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '20px', marginTop: '20px' }}>
                {selectedYear > startYear && (
                    <button style={{ fontSize: '35px' }} onClick={handlePreviousYear} className='mdi mdi-arrow-left-bold-circle-outline'></button>
                )}
                <span style={{ margin: '0 10%', fontSize: '25px' }}>{selectedYear}</span>
                {selectedYear < currentYear - 1 && (
                    <button style={{ fontSize: '35px' }} onClick={handleNextYear} className='mdi mdi-arrow-right-bold-circle-outline'></button>
                )}
            </div>
            <h1 style={{ margin: '20px', fontSize: '20px' }}>월별 기사 발생 횟수</h1>
            <div className="card mb-6">
                {isDataLoaded && (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={chartOptions}
                    />
                )}
            </div>
            <h1 style={{ margin: '20px', fontSize: '20px' }}>월별 기사 워드클라우드 {selectedYear}년 {selectedMonth}</h1>
            <div className="card mb-6">
                {selectedImagePath && <img src={selectedImagePath} style={{margin:"auto"}} alt="Word Cloud" />}
            </div>
        </div>
    );
};

export default ArticleGraphWordCloudPinus;
